import { Component, ChangeDetectionStrategy } from '@angular/core';

import { CurrentUserProfileDialogComponent } from '@core/tellent-smart-ui';
import { TellentWebComponent } from '@core/tellent-types';
import { useProtectedControlsCallback } from '@core/user-interface-routing-logic';

import { DialogWrapComponent } from '../dialog/dialog-wrap.component';

export const getCurrentUserProfileConfig = () => {
  const protectedControls = useProtectedControlsCallback();

  return {
    containerOptions: { fullscreenOnMobile: true },
    closeGuard: () => protectedControls(() => true),
  };
};

@Component({
  selector: 'x-current-user-profile-dialog',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class TellentCurrentUserProfileDialogWrapComponent extends DialogWrapComponent<CurrentUserProfileDialogComponent> {
  public readonly component = CurrentUserProfileDialogComponent;
  public readonly config = getCurrentUserProfileConfig();
}

export type TellentCurrentUserProfileDialogWebComponent = TellentWebComponent<
  TellentCurrentUserProfileDialogWrapComponent,
  'afterClosed' | 'open'
>;
